import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import getDocDefinition from './DocDefinition';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const PrintDocComponent = (
  updateLoader,
  saveAsFile,
  printParams,
  gridApi,
  columnApi,
  name,
  UserDefaultValues,
  hideColumnsInPdf,
  showFooter,
  footerVariableObj,
  fillBackgroundColor,
  info,
  isScrollOn,
  defaultColWidth,
  exportOnlyTotal,
  reportName,
  logInUser,
  skipHeaderRow
) => {
  const docDefinition = getDocDefinition(
    printParams,
    gridApi,
    columnApi,
    name,
    UserDefaultValues,
    hideColumnsInPdf,
    showFooter,
    footerVariableObj,
    fillBackgroundColor,
    info,
    isScrollOn,
    defaultColWidth,
    exportOnlyTotal,
    reportName,
    logInUser,
    skipHeaderRow
  );

  pdfMake
    .createPdf(docDefinition)
    .download(name === undefined ? 'file.pdf' : `${saveAsFile || name}.pdf`);
  updateLoader(false);
};

export default PrintDocComponent;
